import { UserGroupApiModel } from "./UserGroupApiModel";

export class UserApiModel {
    userID: number;
    titleID: number;
    firstName: string;
    lastName: string;
    jobTitle: string;
    organisationID: number;
    email: string;
    mobile: string;
    telephone: string;
    fax: string;
    hasAccess: boolean;
    locked: boolean;
    customerID: number;
    groups: UserGroupApiModel[];
}